/**
 * Полный адрес публичного API для справки на вкладке «Интеграции»
 * (docs/12 §2.3, docs/06 §3.6).
 *
 * Путь берётся из общей константы `PUBLIC_API_PREFIX`, а хост — из адресной
 * строки браузера. Так справка показывает ровно тот адрес, по которому
 * администратор открыл проект, и его можно скопировать интегратору как есть:
 * dev, прод и локальный запуск дают каждый свой адрес без отдельной настройки.
 */

import { PUBLIC_API_PREFIX } from '@tasks/contracts';

/** Убирает хвостовые слэши: `https://tasks.example.ru/` → `https://tasks.example.ru`. */
function trimTrailingSlashes(origin: string): string {
  return origin.replace(/\/+$/, '');
}

/** Полный базовый адрес публичного API: `https://tasks.example.ru/api/v1`. */
export function publicApiUrl(origin: string): string {
  return `${trimTrailingSlashes(origin)}${PUBLIC_API_PREFIX}`;
}

/** Пример запроса к API: `GET https://tasks.example.ru/api/v1/me`. */
export function publicApiCurlUrl(origin: string): string {
  return `${publicApiUrl(origin)}/me`;
}
